/*
import {
  hf,
  ht,
  cr,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as icvBaseK10Rz from './icvBaseK10Rz';
import * as icv_60K10To from './icv_60K10To';
import * as icv_60K10Co from './icv_60K10Co';

export const N = (pz: {
}) => {

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: '祝日',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: 0,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(icvBaseK10Rz.N, {
      key: -10,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icv_60K10To.N, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icv_60K10Co.N, {
          key: -20,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
